import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../api';
import { PageHead } from '../Layout';
import { RunPanel } from '../components/RunPanel';
import type { RunSummary } from '../../shared/types';

export default function ActivityDetail() {
  const { id } = useParams();
  const [run, setRun] = useState<RunSummary | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    setRun(null);
    setError(null);
    void (async () => {
      try {
        setRun(await api.get<RunSummary>(`/runs/${id}`));
      } catch (err) {
        setError(err instanceof Error ? err.message : String(err));
      }
    })();
  }, [id]);

  if (error) return <p className="fail">{error}</p>;
  if (!run) return <div className="empty">Loading…</div>;

  return (
    <>
      <PageHead
        title={`Run ${run.id}`}
        subtitle={`${run.agentSlug} · ${run.trigger}`}
        actions={
          <Link className="btn" to="/activity">
            Back
          </Link>
        }
      />

      <RunPanel run={run} />
    </>
  );
}
